import React from 'react';
import { faUser } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const UserIcon = ({tooltip}) => (
  <Icon tooltip={tooltip || 'Select Member'} iconObj={faUser} />
);

export default UserIcon;